module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-114x114-aa9c6a2c85fd88a588f71ebc2a95167a.png";